var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "popupParent",
      class: [
        "buttons-bottom-header__item",
        "orders-header",
        "_with-popup",
        { _disabled: !_vm.ordersCount },
      ],
      on: { mouseover: _vm.showPopup, mouseout: _vm.hidePopup },
    },
    [
      _c(
        "a",
        {
          staticClass: "buttons-bottom-header__link",
          attrs: { href: "/orders/", "data-list-type": "jsOrderList" },
        },
        [
          _c("div", { staticClass: "buttons-bottom-header__icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "22",
                  height: "22",
                  viewBox: "0 0 22 22",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M14.5 11H16M22.5 11H21M21 11V13.0858C21 13.351 20.8946 13.6054 20.7071 13.7929L16.2929 18.2071C16.1054 18.3946 16 18.649 16 18.9142V21M21 11H16M16 21H21M16 21H14.5M22.5 21H21M21 21V18.9142C21 18.649 20.8946 18.3946 20.7071 18.2071L16.2929 13.7929C16.1054 13.6054 16 13.351 16 13.0858V11",
                    stroke: "#474747",
                    "stroke-width": "1.75",
                    "stroke-linecap": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M12 19H3.70711C3.25435 19 2.82014 18.8201 2.5 18.5V18.5C2.17986 18.1799 2 17.7456 2 17.2929V17C2 15.8954 2.89543 15 4 15V15M12 15H4M4 15V4C4 3.44772 4.44772 3 5 3H18C18.5523 3 19 3.44772 19 4V8",
                    stroke: "#474747",
                    "stroke-width": "1.75",
                    "stroke-linecap": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M11 7H16",
                    stroke: "#474747",
                    "stroke-width": "1.75",
                    "stroke-linecap": "round",
                  },
                }),
                _vm._v(" "),
                _c("circle", {
                  attrs: { cx: "8", cy: "7", r: "1", fill: "#474747" },
                }),
                _vm._v(" "),
                _c("circle", {
                  attrs: { cx: "8", cy: "11", r: "1", fill: "#474747" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "items-count", staticStyle: { display: "none" } },
              [_vm._v("1")]
            ),
            _vm._v(" "),
            _vm.ordersCount
              ? _c(
                  "div",
                  {
                    staticClass:
                      "buttons-bottom-header__icon-count items-count__show",
                  },
                  [_vm._v("\n        " + _vm._s(_vm.ordersCount) + "\n      ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("Статус заказа")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons-bottom-header__item-popup" },
        _vm._l(_vm.orders, function (item, index) {
          return _c("orderBlock", {
            key: "header-orders-" + index,
            staticClass: "order-item",
            attrs: {
              "is-authorized": true,
              "order-title": item.number,
              "order-date": item.dateCreated,
              "order-status": item.status,
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }